var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Country } from "@api/index";
var initialState = {
    apiBasePath: "",
    country: Country.Dk,
    googleMapsApiKey: "",
    shopifyProductId: "",
};
export var ConfigContext = React.createContext(initialState);
ConfigContext.displayName = "ConfigContext";
export var ConfigProvider = function (_a) {
    var config = _a.config, props = __rest(_a, ["config"]);
    var state = __assign(__assign({}, initialState), config);
    return _jsx(ConfigContext.Provider, __assign({ value: state }, props), void 0);
};
export var useConfig = function () {
    var context = React.useContext(ConfigContext);
    if (context === undefined) {
        throw new Error("useApi must be used within a ApiProvider");
    }
    return context;
};
